/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InputAdminElementCaptureRoom } from './InputAdminElementCaptureRoom';
import {
    InputAdminElementCaptureRoomFromJSON,
    InputAdminElementCaptureRoomFromJSONTyped,
    InputAdminElementCaptureRoomToJSON,
} from './InputAdminElementCaptureRoom';

/**
 * 
 * @export
 * @interface InputAdminElementCaptureRooms
 */
export interface InputAdminElementCaptureRooms {
    /**
     * 
     * @type {Array<InputAdminElementCaptureRoom>}
     * @memberof InputAdminElementCaptureRooms
     */
    rooms?: Array<InputAdminElementCaptureRoom>;
}

/**
 * Check if a given object implements the InputAdminElementCaptureRooms interface.
 */
export function instanceOfInputAdminElementCaptureRooms(value: object): boolean {
    return true;
}

export function InputAdminElementCaptureRoomsFromJSON(json: any): InputAdminElementCaptureRooms {
    return InputAdminElementCaptureRoomsFromJSONTyped(json, false);
}

export function InputAdminElementCaptureRoomsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminElementCaptureRooms {
    if (json == null) {
        return json;
    }
    return {
        
        'rooms': json['rooms'] == null ? undefined : ((json['rooms'] as Array<any>).map(InputAdminElementCaptureRoomFromJSON)),
    };
}

export function InputAdminElementCaptureRoomsToJSON(value?: InputAdminElementCaptureRooms | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'rooms': value['rooms'] == null ? undefined : ((value['rooms'] as Array<any>).map(InputAdminElementCaptureRoomToJSON)),
    };
}

